import { xhr } from '@/xhr/endpoints';

//
// state
const state = {};

//
// getters
const getters = {};

//
// mutations
const mutations = {};

//
// actions
const actions = {
  saveSocialShare({ state, getters }, { publicLinkID, network, annotationId }) {
    xhr.addPublicLinkShare(
      publicLinkID,
      getters.documentID,
      annotationId,
      network,
      state.visitor?._id
    );
  },

  async generateSocialPostImage({ state, getters }) {
    const imgateURL = await xhr.generatePostImage(
      getters.publicLinkID,
      state.publicTargetAnnotationId,
      state.publicTargetNetwork
      // state.publicPostMessage,
    );
    console.log('imgateURL', imgateURL);

    return imgateURL;
  },
};

//
// exports
export default {
  // namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
